export default "__VITE_ASSET__DKWnuFjV__"